<template>
  <de-layout-content>
    <div style="font-size: 18px; color: #fff; margin-bottom: 20px; display: flex; align-items: center;"><el-avatar :size="35" :src="info.headImageUrl"></el-avatar>{{'【'+ name +'】' }}数据档案</div>
    <a-row :gutter="24">
      <a-col :span="4">
        <div class="">
          <a-collapse v-model="activeKey">
            <template #expandIcon="props">
              <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
            </template>
            <a-collapse-panel key="1" header="数据档案">
              <div :class="['label', index == selectIndex ? 'active' : '']" v-for="(item, index) in list" :key="index"
                @click="selectItem(item.name, index)">
                {{ item.name }}
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </a-col>
      <a-col :span="20">
        <!-- <sportVideo v-if="selectIndex == 0" :userId="query.id"></sportVideo>
        <drillData v-if="selectIndex == 1" :userId="query.id"></drillData>
        <videoAnalyse v-if="selectIndex == 2"></videoAnalyse>
        <surveyData v-if="selectIndex == 3"></surveyData>
        <medical v-if="selectIndex == 4"></medical> -->

        <TrainingVideo v-if="selectIndex == 0"></TrainingVideo>
        <TrainingData v-if="selectIndex == 1"></TrainingData>
        <AnalysisResults v-if="selectIndex == 2"></AnalysisResults>
        <Questionnaire v-if="selectIndex == 3"></Questionnaire>

        <!-- 医务监督/伤病档案/体能指标/心理调控/营养补充/战术分析/技术分析-7个 -->
        <Medical
          v-if="selectIndex == 4 || selectIndex == 5 || selectIndex == 6 || selectIndex == 7 || selectIndex == 8 || selectIndex == 9 || selectIndex == 10" :name="activeName" :key="componentKey"></Medical>
      </a-col>
    </a-row>
  </de-layout-content>
</template>

<script>
import * as API_Member from "@/api/train/member";
// 训练视频
import TrainingVideo from "../components/athetes/TrainingVideo.vue";
// 训练数据
import TrainingData from "../components/athetes/TrainingData.vue";
// 分析结果
import AnalysisResults from "../components/athetes/AnalysisResults.vue";
// 调查问卷
import Questionnaire from "../components/athetes/DailyQuestionnaire.vue";
// 旧模版医务监督（测试没问题即可删除文件）
// import PhysiologyData from "../components/athetes/healthRecords/PhysiologyData.vue";
// 新模版数据档案-lc- 医务监督 / 伤病档案 / 体能指标 / 心理调控 / 营养补充 / 战术分析 / 技术分析 - 7个
import Medical from "../components/athetes/Medical.vue";

export default {
  components: {
    TrainingVideo,
    TrainingData,
    AnalysisResults,
    Questionnaire,
    // PhysiologyData,
    Medical
    // HealthRecords
  },
  data() {
    return {
      // activeKey: +this.$route.query.type ?? 3,
      activeKey: ["1"],
      ismenu: false,
      selectIndex: 0,
      name:'',
      info: {},
      activeName:'',
      componentKey:null,
      list: [
        {
          name: "运动视频",
        },
        {
          name: "训练数据",
        },
        {
          name: "视频分析",
        },
        {
          name: "调查问卷",
        },
        {
          name: "医务监督",
        },
        {
          name: "伤病档案",
        },
        {
          name: "体能指标",
        },
        {
          name: "疲劳恢复",
        },
        // {
        //   name:"机能评定检测中心"
        // },
        // {
        //   name: "营养补充",
        // },
        {
          name: "战术分析",
        },
        {
          name: "技术分析",
        },
      ],
    };
  },
  provide() {
    return {
      getId: () => this.id,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.name = this.$route.query.name;
    this.getInfo()
  },
  watch: {
    $route: {
      // handler(val) {
      //   const type = val.query.type;
      //   const ismenu = val.query.menu;
      //   if (type) {
      //     this.activeKey = +val.query.type;
      //   }
      //   this.ismenu = !!ismenu;
      // },
      // immediate: true
    },
  },
  mounted() {},
  methods: {

    selectItem(item, index) {
      this.selectIndex = index;
      console.log('selectItem');
      console.log(item);
      this.activeName = item
    },

    getInfo() {
      API_Member.memberInfo(this.id).then((res) => {
        console.log(res, "res");
        if (res.code == 200) {
          this.info = res.data;
          this.componentKey = this.memberId
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.label {
  padding: 0 16px;
  height: 52px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.active {
  background-color: rgba(247, 250, 253, 1);
  color: rgb(64, 158, 255);
}

.header {
  background-color: #e4e4e4;
}
::v-deep.ant-collapse-content-box {
  padding: 0;
}
</style>
